import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { NamirasoftBillWatchServer } from "namirasoft-bill-watch";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftCredentialServer } from "namirasoft-credential";
import { NamirasoftNotificationSenderServer } from "namirasoft-notification-sender";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { BillWatchLayout } from "./BillWatchLayout";
import { BillWatchRoutes } from "./BillWatchRoutes";
import AWSEditPage from "./pages/AWSEditPage";
import AWSListPage from "./pages/AWSListPage";
import AWSViewPage from "./pages/AWSViewPage";
import AzureEditPage from "./pages/AzureEditPage";
import AzureListPage from "./pages/AzureListPage";
import AzureViewPage from "./pages/AzureViewPage";
import GCPEditPage from "./pages/GCPEditPage";
import GCPListPage from "./pages/GCPListPage";
import GCPViewPage from "./pages/GCPViewPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RuleBastionSimulationPage from "./pages/RuleBastionSimulationPage";
import RuleEditPage from "./pages/RuleEditPage";
import RuleListPage from "./pages/RuleListPage";
import RuleSimulatorPage from "./pages/RuleSimulatorPage";
import RuleViewPage from "./pages/RuleViewPage";
import UsagePage from "./pages/UsagePage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_BILL_WATCH}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_BILL_WATCH = new EnvService("REACT_APP_BASE_URL_BILL_WATCH", true).getString();
            let REACT_APP_BASE_URL_CREDENTIAL = new EnvService("REACT_APP_BASE_URL_CREDENTIAL", true).getString();
            let REACT_APP_BASE_URL_NOTIFICATION_SENDER = new EnvService("REACT_APP_BASE_URL_NOTIFICATION_SENDER", true).getString();

            let bill_watch = new NamirasoftBillWatchServer(REACT_APP_BASE_URL_BILL_WATCH, result.account.token_manager, result.notifier.onError);
            let credential = new NamirasoftCredentialServer(REACT_APP_BASE_URL_CREDENTIAL, result.account.token_manager, result.notifier.onError);
            let notification_sender = new NamirasoftNotificationSenderServer(REACT_APP_BASE_URL_NOTIFICATION_SENDER, result.account.token_manager, result.notifier.onError);

            let servers = { bill_watch, credential, notification_sender };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={BillWatchRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={BillWatchRoutes.AWSList} element={<AWSListPage {...result} servers={servers} />} />
                            <Route path={BillWatchRoutes.AWSNew} element={<AWSEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={BillWatchRoutes.AWSCopy(":id")} element={<AWSEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={BillWatchRoutes.AWSEdit(":id")} element={<AWSEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={BillWatchRoutes.AWSView(":id")} element={<AWSViewPage {...result} servers={servers} />} />

                            <Route path={BillWatchRoutes.AzureList} element={<AzureListPage {...result} servers={servers} />} />
                            <Route path={BillWatchRoutes.AzureNew} element={<AzureEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={BillWatchRoutes.AzureCopy(":id")} element={<AzureEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={BillWatchRoutes.AzureEdit(":id")} element={<AzureEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={BillWatchRoutes.AzureView(":id")} element={<AzureViewPage {...result} servers={servers} />} />

                            <Route path={BillWatchRoutes.GCPList} element={<GCPListPage {...result} servers={servers} />} />
                            <Route path={BillWatchRoutes.GCPNew} element={<GCPEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={BillWatchRoutes.GCPCopy(":id")} element={<GCPEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={BillWatchRoutes.GCPEdit(":id")} element={<GCPEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={BillWatchRoutes.GCPView(":id")} element={<GCPViewPage {...result} servers={servers} />} />

                            <Route path={BillWatchRoutes.RuleList} element={<RuleListPage {...result} servers={servers} />} />
                            <Route path={BillWatchRoutes.RuleNew} element={<RuleEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={BillWatchRoutes.RuleCopy(":id")} element={<RuleEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={BillWatchRoutes.RuleEdit(":id")} element={<RuleEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={BillWatchRoutes.RuleView(":id")} element={<RuleViewPage {...result} servers={servers} />} />
                            <Route path={BillWatchRoutes.RuleBatchSimulation} element={<RuleBastionSimulationPage {...result} servers={servers} />} />
                            <Route path={BillWatchRoutes.RuleSimulator} element={<RuleSimulatorPage {...result} servers={servers} />} />

                            <Route path={BillWatchRoutes.Usage} element={<UsagePage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes>
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={BillWatchRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <BillWatchLayout {...props}>
                {props.children}
            </BillWatchLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: true
            }
        }}
    />
}

export default Router;